import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEN from './localize/en/translationEN.json';
import translationID from './localize/id/translationID.json';
import { getLocalStorage, lanSetting } from "./utils";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)

const resources = {
  en: {
    translation: translationEN
  },
  id: {
    translation: translationID
  }
};

const userId = getLocalStorage(lanSetting.user_id)
const lanConst = getLocalStorage(lanSetting.lan_set)
let jsonGet = Array.isArray(lanConst) === true ? lanConst : JSON.parse(lanConst);
let currLang = 'en'

if(jsonGet.length > 0){
  for(var i=0;i<jsonGet.length;i++){
    if(jsonGet[i][lanSetting.user_id] === parseInt(userId)){
        currLang = jsonGet[i][lanSetting.lan];
    }
  }
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: currLang, // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;